import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MdSearch } from "react-icons/md";
import { useSnackbar } from "notistack";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import { fetchWorkEntries, fetchWorkEntriesProjectTracking } from "../../../../../store/slices/workentriesSlice";
import { fetchDescriptionTasks, fetchDescriptionTasksProjectTracking } from "../../../../../store/slices/DescriptionTask";
import { fetchHardwareProjectTracking } from "../../../../../store/slices/hardwareDescriptionSlice";
import { fetchAllProjects } from "../../../../../store/slices/projectsSlice";
import { fetchEmployees } from "../../../../../store/slices/employeeSlice";
import { fetchLeads } from "../../../../../store/slices/leadsSlice";
import { replaceWorkEntriesProjectTrack, saveUpdateDescriptionTask } from "../../../../../store/slices/managerEditTrackingEntries";
import AdminLoader from "../../../../../components/common/loader/AdminLoader";
import FileUploadOP from "../../../Operationperson/FileUploadOP";
import OPProjectAssignActionPM from "./OPProjectAssignActionPM";
import OPProjectAssignOpHardwrePM from "./OPProjectAssignOpHardwrePM";
import DateConversion from "../../../../../utils/DateConversion";
import { consolidateTrainingExpenseRowsForDisplay } from "../../../../../utils/trainingOtherExpenseSync";

const OPProjectassignPM = ({ EmpEmail, assignedOpProjects, isViewOnly = false }) => {
   const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const { formatDateByCountry } = DateConversion();
  
    const { employees } = useSelector((state) => state.employees);
    const { projectTrackingWorkEntries } = useSelector(
      (state) => state.workentries
    );
    const { hardwareProjectTracking } = useSelector(
      (state) => state.hardwareDescription
    );
    const { descriptionProjectTracking } = useSelector(
      (state) => state.descriptionTasks
    );
    const { leads } = useSelector((state) => state.leads);
  
    const { entries } = useSelector((state) => state.workentries);
    const { tasks } = useSelector((state) => state.descriptionTasks);
  const LoggedUser = EmpEmail
  
    useEffect(() => {
      dispatch(fetchWorkEntriesProjectTracking());
      dispatch(fetchDescriptionTasksProjectTracking());
      dispatch(fetchHardwareProjectTracking());
      dispatch(fetchAllProjects());
      dispatch(fetchEmployees());
      dispatch(fetchLeads());
      dispatch(fetchDescriptionTasks());
      dispatch(fetchWorkEntries());
    }, [dispatch]);
  
    const [isLoading, setIsLoading] = useState(false);
    const [confirmAssignPopup, setConfirmAssignPopup] = useState(false);
    const [showActionToAssign] = useState({
      0: "tasktable",
    });
    const [showTaskTable, SetshowTaskTable] = useState(null);
    const [openTaskIndex, setOpenTaskIndex] = useState(null);
    const [tripDurationInput, setTripDuration] = useState();
  
    const wrapperRef = useRef(null);
    const [openMenuIdx, setOpenMenuIdx] = useState(null); // null = no menu open
  
    useEffect(() => {
      function handleClickOutside(event) {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
          setOpenMenuIdx(null);
        }
      }
      document.addEventListener("click", handleClickOutside);
      return () => {
        document.removeEventListener("click", handleClickOutside);
      };
    }, [setOpenMenuIdx]);
  
    const [selectedProjectId, setSelectedProjectId] = useState(null);
    const [projectTasksEntries, setProjectTasksEntries] = useState([]);
    const [projectDescriptionEntries, setProjectDescriptionEntries] = useState([
      { description: "", value: "", notes: "" },
    ]);
    const [projectHardwareParts, setProjectHardwareParts] = useState([]);
  
    const handleSelectProjectWorkEntries = (projectId, matchedRowEntries) => {
      // If selecting a new project, load its entries
      if (projectId !== selectedProjectId) {
        setSelectedProjectId(projectId);
        setProjectTasksEntries(
          matchedRowEntries.length > 0
            ? matchedRowEntries.map((entry) => ({ ...entry }))
            : [{ task: "", hoursassigned: "", notes: "" }]
        );
      }
    };
  
    const handleSelectProjectDescription = (projectId, matchedRowDesctiption) => {
      // If selecting a new project, load its entries
      if (projectId !== selectedProjectId) {
        setSelectedProjectId(projectId);
        setProjectDescriptionEntries(
          matchedRowDesctiption.length > 0
            ? consolidateTrainingExpenseRowsForDisplay(
                matchedRowDesctiption.map((entry) => ({ ...entry }))
              )
            : [{ description: "", value: "", notes: "" }]
        );
      }
    };
  
    const handleSelectProjectHardwareParts = (
      projectId,
      matchedRowHardwareEntries
    ) => {
      // If selecting a new project, load its entries
      if (projectId !== selectedProjectId) {
        setSelectedProjectId(projectId);
        setProjectHardwareParts(
          matchedRowHardwareEntries.length > 0
            ? matchedRowHardwareEntries.map((entry) => ({ ...entry }))
            : [
                {
                  assemblepartdescription: "",
                  partno: "",
                  quantity: "",
                  unitprice: "",
                  totalprice: "",
                },
              ]
        );
      }
    };
  
    const handleWorkEntriesSubmit = async () => {
      if (isViewOnly) return;
      const cleanedEntries = projectTasksEntries
        .filter((entry) => {
          return (
            entry?.task !== null &&
            entry?.task !== undefined &&
            entry?.task !== "" &&
            entry?.hoursassigned !== null &&
            entry?.hoursassigned !== undefined &&
            entry?.hoursassigned !== ""
          );
        })
        .map((entry) => ({
          _id: entry?._id || null,
          task: entry.task,
          hoursassigned: Number(entry.hoursassigned),
          hoursspent: entry.hoursspent,
          startdate: entry.startdate,
          enddate: entry.enddate,
          expenses: entry.expenses,
          notes: entry.notes,
          oldtaskid: entry.oldtaskid || null,
        }));
  
      const Payload = {
        projectid: selectedProjectId,
        tasktype: "self",
        newEntries: cleanedEntries,
      };
      setIsLoading(true);
      try {
        await dispatch(replaceWorkEntriesProjectTrack(Payload));
        enqueueSnackbar("WorkEntries Saved", {
          variant: "success",
        });
        setIsLoading(false);
        dispatch(fetchAllProjects());
        dispatch(fetchWorkEntriesProjectTracking());
      } catch {
        enqueueSnackbar("Failed to save workentries", {
          variant: "error",
        });
        setIsLoading(false);
      } finally {
        setIsLoading(false);
      }
    };
  
    const handleDescriptionEntriesSubmit = async (row) => {
      if (isViewOnly) return;
      const cleanedDescriptionEntries = projectDescriptionEntries
        .filter((entry) => {
          return (
            entry?.description !== null &&
            entry?.description !== undefined &&
            entry?.description !== "" &&
            entry?.value !== null &&
            entry?.value !== undefined &&
            entry?.value !== ""
          );
        })
        .map((entry) => ({
          _id: entry?._id || null,
          description: entry.description,
          value: entry.value,
          notes: entry.notes,
          oldtaskid: entry.oldtaskid || null,
          tripduration: row?.TypeService?.toLowerCase()?.includes("installation")
            ? Number(tripDurationInput) ?? entry.tripduration ?? null
            : entry.tripduration ?? null,
        }));
  
      const Payload = {
        projectid: selectedProjectId,
        tasktype: "self",
        entries: cleanedDescriptionEntries,
      };
  
      setIsLoading(true);
      try {
        await dispatch(saveUpdateDescriptionTask(Payload));
        enqueueSnackbar("Description Entries Saved", {
          variant: "success",
        });
        setIsLoading(false);
        dispatch(fetchAllProjects());
        dispatch(fetchDescriptionTasksProjectTracking());
      } catch {
        enqueueSnackbar("Failed to save Description", {
          variant: "error",
        });
        setIsLoading(false);
      } finally {
        setIsLoading(false);
      }
    };
  
    const [loggedEmp, setLoggedEmp] = useState(null);
  
    useEffect(() => {
      const loggedInUserEmail = localStorage.getItem("email");
      const loggedInEmployee = employees.find(
        (emp) => emp.EmpEmail === loggedInUserEmail
      );
      setLoggedEmp(loggedInEmployee);
    }, [employees]);
  
    const [projectData, setProjectData] = useState([]);
  
    useEffect(() => {
      if (!assignedOpProjects) return;
  
      const computedData = assignedOpProjects.map((row) => {
        const matchedRowEntries = projectTrackingWorkEntries.filter(
          //     (entry) =>
          //     entry?.projectid === row._id &&
          //     entry?.typeservice === loggedEmp?.ServiceType
          // );
          (entry) =>
            entry?.projectid === row._id &&
            entry?.taskownerid === loggedEmp?._id &&
            entry.isProjectAssigned === true
        );
  
        const matchedRowDesctiption = consolidateTrainingExpenseRowsForDisplay(
          descriptionProjectTracking
            .filter(
              (entry) =>
                entry?.projectid === row._id &&
                entry?.taskownerid === loggedEmp?._id &&
                entry.isProjectAssigned === true
            )
            .map((entry) => ({ ...entry }))
        );
  
        const matchedRowHardwareEntries = hardwareProjectTracking.filter(
          (entry) =>
            entry?.projectid === row._id &&
            entry?.taskownerid === loggedEmp?._id &&
            entry.isProjectAssigned === true
        );
  
        const matchedOldRowWorkEntries = entries.filter(
          (entry) => entry?.projectid === row._id
        );
        const matchedOldRowDesctiption = tasks.filter(
          (entry) => entry?.projectid === row._id
        );
  
        return {
          row: row,
          projectid: row._id,
          matchedRowEntries,
          matchedRowDesctiption,
          matchedRowHardwareEntries,
          matchedOldRowDesctiption,
          matchedOldRowWorkEntries,
        };
      });
  
      setProjectData(computedData);
    }, [
      assignedOpProjects,
      projectTrackingWorkEntries,
      descriptionProjectTracking,
      hardwareProjectTracking,
      loggedEmp,
      tasks,
      entries,
    ]);
  
    const [currentPage, setCurrentPage] = useState(1);
    const [sortedProjects, setSortedProjects] = useState([]);
  
    useEffect(() => {
      setSortedProjects(assignedOpProjects);
    }, [assignedOpProjects]);
  
    const [searchQuery, setSearchQuery] = useState("");
  
    const handleSearchInputChange = (e) => {
      const query = e.target.value;
      setSearchQuery(query);
      filterLeadReports(query);
      setCurrentPage(1);
    };
  
    const itemsPerPage = 10; // or any number of rows you want per page
    const [showListState, setShowListState] = useState("tasktable");
    const [clickedProject, setClickedProject] = useState(null);
  
    const totalItems = sortedProjects?.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
  
    const startIdx = (currentPage - 1) * itemsPerPage;
    const endIdx = startIdx + itemsPerPage;
    const paginatedProjects = sortedProjects?.slice(startIdx, endIdx);
  
    const filterLeadReports = (query) => {
      const lowerCaseQuery = query.toLowerCase().trim();
  
      const filtered = assignedOpProjects.filter((LeadReport) =>
        Object.entries(LeadReport).some(([key, value]) => {
          // Skip these keys
          if (
            key === "Assignedperson" ||
            key === "TypeService" ||
            key === "SalesPersonName" ||
            key === "SalesPersonEmail" ||
            key === "ResourceType" ||
            key === "QuotedValue" ||
            key === "ProjectManagerStatus" ||
            key === "ProjectManagerAction" ||
            key === "createdAt" ||
            key === "updatedAt" ||
            key === "PrimaryResources"
          )
            return false;
  
          if (value === null || value === undefined) return false;
          if (key === "DateRequested" || key === "ProjectDueDate") {
            const formattedDate = formatDateByCountry(value); // ← change here
            return formattedDate.toLowerCase().includes(lowerCaseQuery);
          }
  
          // Handle all other fields
          const formattedValue = value.toString().trim().toLowerCase();
          return formattedValue.includes(lowerCaseQuery);
        })
      );
  
      setSortedProjects(filtered);
    };
  
    const sortAlphabetically = (targetToSort, order) => {
      const key = `${targetToSort}-${order}`;
      let sorted = [...sortedProjects]; // Always sort from the filtered dataset
  
      const compareStrings = (a, b) => {
        const valA = (a || "").toString().toLowerCase();
        const valB = (b || "").toString().toLowerCase();
        return valA.localeCompare(valB);
      };
      // Helper function for date comparison
      const compareDates = (a, b) => {
        const dateA = a ? new Date(a) : null;
        const dateB = b ? new Date(b) : null;
  
        if (!dateA && !dateB) return 0;
        if (!dateA) return 1;
        if (!dateB) return -1;
  
        return dateA - dateB;
      };
  
      switch (key) {
        case "AssignedGroup-az":
          sorted.sort((a, b) => compareStrings(a.AssignedGroup, b.AssignedGroup));
          break;
        case "AssignedGroup-za":
          sorted.sort((a, b) => compareStrings(b.AssignedGroup, a.AssignedGroup));
          break;
        case "ProjectName-az":
          sorted.sort((a, b) => compareStrings(a.ProjectName, b.ProjectName));
          break;
        case "ProjectName-za":
          sorted.sort((a, b) => compareStrings(b.ProjectName, a.ProjectName));
          break;
        case "DateRequested-az":
          sorted.sort((a, b) => compareDates(a.DateRequested, b.DateRequested));
          break;
        case "DateRequested-za":
          sorted.sort((a, b) => compareDates(b.DateRequested, a.DateRequested));
          break;
        case "ProjectDueDate-az":
          sorted.sort((a, b) => compareDates(a.ProjectDueDate, b.ProjectDueDate));
          break;
        case "ProjectDueDate-za":
          sorted.sort((a, b) => compareDates(b.ProjectDueDate, a.ProjectDueDate));
          break;
        default:
          // Default to original filtered order
          sorted = [...sortedProjects];
          break;
      }
  
      setSortedProjects(sorted);
      setCurrentPage(1); // Reset to first page after sorting
    };
  
    const ProjectAssignedRef = useRef(null);
  
    useEffect(() => {
      if (showTaskTable) {
        // Scroll to the right end of the container
        const scrollToPosition = ProjectAssignedRef.current.scrollWidth;
        ProjectAssignedRef.current.scrollTo({
          left: scrollToPosition,
          behavior: "smooth",
        });
      }
    }, [showTaskTable]);
  
  return (
     <div>
          {isLoading ? <AdminLoader isLoading={isLoading} /> : <></>}
          <>
            <div className="mt-4 rounded-t-md min-h-[35vh] max-h-[90vh] h-full pb-15 bg-white">
              <div className=" flex justify-between items-center p-2">
                <div className=" font-semibold">
                  <h3>Project Assigned</h3>
                </div>
    
                <div className="flex gap-2 p-1 align-middle items-center bg-[#e0e7ff] rounded-full">
                  <MdSearch className=" w-5 h-5 text-gray-500" />
                  <input
                    type="text"
                    value={searchQuery}
                    onChange={handleSearchInputChange}
                    placeholder="Search"
                    className="bg-[#e0e7ff] outline-none w-[80%]"
                  />
                </div>
              </div>
    
              <div
                ref={ProjectAssignedRef}
                className={`h-full overflow-auto pb-3 bg-white `}
              >
                <div
                  className={`${
                    showTaskTable ? "min-w-[1170px]" : "min-w-[970px]"
                  }  bg-[#E8E8E8] text-black flex  text-xs text-center sticky top-0 z-[1299] `}
                >
                  <div
                    className={`${
                      showTaskTable ? "w-[65%]" : "w-[100%]"
                    } flex bg-[#E8E8E8] font-semibold`}
                  >
                    <div className="w-[6%] flex justify-start align-middle items-center border p-3 h-12">
                      Sr. No
                    </div>
                    <div className="w-[18%] relative flex justify-start align-middle items-center border p-2 break-words text-wrap h-12">
                      <p className="w-[70%] text-start break-words whitespace-normal">
                        Group
                      </p>
                      <div className="w-[30%] absolute right-2 flex flex-col">
                        <div
                          className="cursor-pointer "
                          onClick={() => sortAlphabetically("AssignedGroup", "az")}
                        >
                          <ArrowDropUp color="white" sx={{ fontSize: "22px" }} />
                        </div>
                        <div
                          className="cursor-pointer -mt-2"
                          onClick={() => sortAlphabetically("AssignedGroup", "za")}
                        >
                          <ArrowDropDown color="white" sx={{ fontSize: "22px" }} />
                        </div>
                      </div>
                    </div>
                    <div className="w-[17%] relative flex justify-start align-middle items-center border p-2 break-words text-wrap h-12">
                      <p className="w-[75%] text-start break-words whitespace-normal">
                        Project
                      </p>
                      <div className="w-[25%] absolute right-2 flex flex-col">
                        <div
                          className="cursor-pointer "
                          onClick={() => sortAlphabetically("ProjectName", "az")}
                        >
                          <ArrowDropUp color="white" sx={{ fontSize: "22px" }} />
                        </div>
                        <div
                          className="cursor-pointer -mt-2"
                          onClick={() => sortAlphabetically("ProjectName", "za")}
                        >
                          <ArrowDropDown color="white" sx={{ fontSize: "22px" }} />
                        </div>
                      </div>
                    </div>
                    <div className="w-[17%] relative flex justify-center align-middle items-center border p-2 break-words text-wrap h-12">
                      <p className="w-[75%] flex justify-center items-center break-words whitespace-normal">
                        {" "}
                        Date Requested{" "}
                      </p>
                      <div className="w-[25%] flex flex-col">
                        <div
                          className="cursor-pointer "
                          onClick={() => sortAlphabetically("DateRequested", "az")}
                        >
                          <ArrowDropUp color="white" sx={{ fontSize: "22px" }} />
                        </div>
                        <div
                          className="cursor-pointer -mt-2"
                          onClick={() => sortAlphabetically("DateRequested", "za")}
                        >
                          <ArrowDropDown color="white" sx={{ fontSize: "22px" }} />
                        </div>
                      </div>
                    </div>
                    <div className="w-[17%] relative flex justify-center align-middle items-center border p-2 break-words text-wrap h-12">
                      <p className="w-[65%] pl-2 flex justify-center items-center break-words whitespace-normal">
                        {" "}
                        Due Date
                      </p>
                      <div className="w-[35%] flex flex-col">
                        <div
                          className="cursor-pointer "
                          onClick={() => sortAlphabetically("ProjectDueDate", "az")}
                        >
                          <ArrowDropUp color="white" sx={{ fontSize: "22px" }} />
                        </div>
                        <div
                          className="cursor-pointer -mt-2"
                          onClick={() => sortAlphabetically("ProjectDueDate", "za")}
                        >
                          <ArrowDropDown color="white" sx={{ fontSize: "22px" }} />
                        </div>
                      </div>
                    </div>
                    <div className="w-[10%] flex justify-center align-middle items-center border p-2 break-words text-wrap h-12">
                      Attachment
                    </div>
                    <div className="w-[17%] flex justify-center align-middle items-center border p-2 break-words text-wrap h-12">
                      Action
                    </div>
                  </div>
                  <div
                    className={`font-semibold flex ${
                      showTaskTable ? "w-[35%]" : "w-[0%] hidden "
                    } `}
                  >
                    <div className="w-[100%] bg-[#E8E8E8] text-black  break-words text-wrap h-12">
                      <div className="w-full h-[50%] p-2  break-words text-wrap flex justify-center items-center">
                        Task Details
                      </div>
                      <div className="w-full h-[50%] break-words text-wrap flex ">
                        <div
                          onClick={() => setShowListState("tasktable")}
                          className={`w-[50%] ${
                            showListState === "tasktable"
                              ? "bg-blue-500 text-white"
                              : "text-black"
                          }  p-2 cursor-pointer flex justify-center items-center`}
                        >
                          {clickedProject?.TypeService?.toLowerCase().includes(
                            "hardware"
                          )
                            ? "Part List"
                            : "Effort Expenses"}
                        </div>
                        <div
                          onClick={() => setShowListState("otherexpenses")}
                          className={` w-[50%] ${
                            showListState === "otherexpenses"
                              ? "bg-blue-500 text-white"
                              : "text-black"
                          } p-2  cursor-pointer flex justify-center items-center`}
                        >
                          Other Expenses
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
    
                <div
                  className={`${
                    showTaskTable ? "min-w-[1170px]" : "min-w-[970px]"
                  }  bg-white z-[999] pb-10 `}
                >
                  {paginatedProjects?.map((row, index) => {
                    const isUserAssigned = row.Assignedperson?.find(
                      (person) => person.email === LoggedUser // replace with your actual logged user email variable
                    );
                    return (
                      <div
                        className={`flex text-xs w-full ${
                          isUserAssigned.isRead === false ? " font-bold" : ""
                        } bg-white hover:bg-gray-100 `}
                        key={index}
                        onClick={() => {}}
                      >
                        <div
                          className={` flex ${
                            showTaskTable ? "w-[65%]" : "w-[100%]"
                          } `}
                        >
                          <div
                            onClick={() => {
                              setClickedProject(row);
                              SetshowTaskTable(
                                showTaskTable === row?._id ? null : row?._id
                              );
                              setOpenTaskIndex(
                                openTaskIndex === index ? null : index
                              );
                              handleSelectProjectWorkEntries(
                                row._id,
                                projectData.find((p) => p.projectid === row._id)
                                  ?.matchedRowEntries || []
                              );
                              handleSelectProjectDescription(
                                row._id,
                                projectData.find((p) => p.projectid === row._id)
                                  ?.matchedRowDesctiption || []
                              );
                              handleSelectProjectHardwareParts(
                                row._id,
                                projectData.find((p) => p.projectid === row._id)
                                  ?.matchedRowHardwareEntries || []
                              );
                            }}
                            className="w-[6%] cursor-pointer border-b flex justify-start align-middle items-center p-3 "
                          >
                            {startIdx + index + 1}
                          </div>
                          <div
                            onClick={() => {
                              setClickedProject(row);
                              SetshowTaskTable(
                                showTaskTable === row?._id ? null : row?._id
                              );
                              setOpenTaskIndex(
                                openTaskIndex === index ? null : index
                              );
                              handleSelectProjectWorkEntries(
                                row._id,
                                projectData.find((p) => p.projectid === row._id)
                                  ?.matchedRowEntries || []
                              );
                              handleSelectProjectDescription(
                                row._id,
                                projectData.find((p) => p.projectid === row._id)
                                  ?.matchedRowDesctiption || []
                              );
                              handleSelectProjectHardwareParts(
                                row._id,
                                projectData.find((p) => p.projectid === row._id)
                                  ?.matchedRowHardwareEntries || []
                              );
                            }}
                            className="w-[18%] border-b cursor-pointer flex justify-start align-middle items-center  p-2 break-words text-wrap"
                          >
                            {row.AssignedGroup}
                          </div>
                          <div
                            onClick={() => {
                              setClickedProject(row);
                              SetshowTaskTable(
                                showTaskTable === row?._id ? null : row?._id
                              );
                              setOpenTaskIndex(
                                openTaskIndex === index ? null : index
                              );
                              handleSelectProjectWorkEntries(
                                row._id,
                                projectData.find((p) => p.projectid === row._id)
                                  ?.matchedRowEntries || []
                              );
                              handleSelectProjectDescription(
                                row._id,
                                projectData.find((p) => p.projectid === row._id)
                                  ?.matchedRowDesctiption || []
                              );
                              handleSelectProjectHardwareParts(
                                row._id,
                                projectData.find((p) => p.projectid === row._id)
                                  ?.matchedRowHardwareEntries || []
                              );
                            }}
                            className="w-[17%] border-b cursor-pointer flex justify-start align-middle items-center text-left p-2 break-words whitespace-normal overflow-hidden text-ellipsis line-clamp-2 leading-snug text-xs"
                          >
                            {row.ProjectName}
                          </div>
                          <div
                            onClick={() => {
                              setClickedProject(row);
                              SetshowTaskTable(
                                showTaskTable === row?._id ? null : row?._id
                              );
                              setOpenTaskIndex(
                                openTaskIndex === index ? null : index
                              );
                              handleSelectProjectWorkEntries(
                                row._id,
                                projectData.find((p) => p.projectid === row._id)
                                  ?.matchedRowEntries || []
                              );
                              handleSelectProjectDescription(
                                row._id,
                                projectData.find((p) => p.projectid === row._id)
                                  ?.matchedRowDesctiption || []
                              );
                              handleSelectProjectHardwareParts(
                                row._id,
                                projectData.find((p) => p.projectid === row._id)
                                  ?.matchedRowHardwareEntries || []
                              );
                            }}
                            className="w-[17%] border-b cursor-pointer flex justify-center align-middle items-center  p-2 break-words text-wrap"
                          >
                            {row.DateRequested &&
                            !isNaN(new Date(row.DateRequested))
                              ? formatDateByCountry(row.DateRequested)
                              : " "}
                          </div>
                          <div
                            onClick={() => {
                              setClickedProject(row);
                              SetshowTaskTable(
                                showTaskTable === row?._id ? null : row?._id
                              );
                              setOpenTaskIndex(
                                openTaskIndex === index ? null : index
                              );
                              handleSelectProjectWorkEntries(
                                row._id,
                                projectData.find((p) => p.projectid === row._id)
                                  ?.matchedRowEntries || []
                              );
                              handleSelectProjectDescription(
                                row._id,
                                projectData.find((p) => p.projectid === row._id)
                                  ?.matchedRowDesctiption || []
                              );
                              handleSelectProjectHardwareParts(
                                row._id,
                                projectData.find((p) => p.projectid === row._id)
                                  ?.matchedRowHardwareEntries || []
                              );
                            }}
                            className="w-[17%] border-b flex cursor-pointer justify-center align-middle items-center  p-2 break-words text-wrap"
                          >
                            {row.ProjectDueDate &&
                            !isNaN(new Date(row.ProjectDueDate))
                              ? formatDateByCountry(row.ProjectDueDate)
                              : " "}{" "}
                          </div>
                          <div className="w-[10%] border-b p-2 flex justify-center align-middle items-center break-words text-wrap">
                            <FileUploadOP
                              project={row}
                              leads={leads}
                              employees={employees}
                              isViewOnly={isViewOnly}
                            />
                          </div>
                          <div className="w-[17%] border-b p-1 text-center flex justify-center align-middle items-center break-words text-wrap">
                            <OPProjectAssignActionPM
                              isViewOnly={isViewOnly}
                              setClickedProject={setClickedProject}
                              SetshowTaskTable={SetshowTaskTable}
                              showTaskTable={showTaskTable}
                              setOpenTaskIndex={setOpenTaskIndex}
                              openTaskIndex={openTaskIndex}
                              openMenuIdx={openMenuIdx}
                              setOpenMenuIdx={setOpenMenuIdx}
                              setIsLoading={setIsLoading}
                              index={index}
                              row={row}
                              handleSelectProjectWorkEntries={
                                handleSelectProjectWorkEntries
                              }
                              handleSelectProjectHardwareParts={
                                handleSelectProjectHardwareParts
                              }
                              handleSelectProjectDescription={
                                handleSelectProjectDescription
                              }
                              matchedRowEntries={
                                projectData.find((p) => p.projectid === row._id)
                                  ?.matchedRowEntries || []
                              }
                              matchedRowDesctiption={
                                projectData.find((p) => p.projectid === row._id)
                                  ?.matchedRowDesctiption || []
                              }
                              matchedRowHardwareEntries={
                                projectData.find((p) => p.projectid === row._id)
                                  ?.matchedRowHardwareEntries || []
                              }
                              projectData={projectData}
                            />
                          </div>
                        </div>
                        <div
                          className={` flex flex-col h-full  ${
                            showTaskTable ? "w-[35%]" : "w-[0%] hidden"
                          }`}
                        >
                          {openTaskIndex === index ? (
                            <div className="w-[100%] border-b  font-medium  items-center justify-center text-center break-words">
                              <OPProjectAssignOpHardwrePM
                                isViewOnly={isViewOnly}
                                showListState={showListState}
                                row={row}
                                index={index}
                                showActionToAssign={showActionToAssign}
                                handleWorkEntriesSubmit={handleWorkEntriesSubmit}
                                handleDescriptionEntriesSubmit={
                                  handleDescriptionEntriesSubmit
                                }
                                setProjectTasksEntries={setProjectTasksEntries}
                                setProjectDescriptionEntries={
                                  setProjectDescriptionEntries
                                }
                                setProjectHardwareParts={setProjectHardwareParts}
                                matchedRowEntries={
                                  projectData.find((p) => p.projectid === row._id)
                                    ?.matchedRowEntries || []
                                }
                                matchedRowHardwareEntries={
                                  projectData.find((p) => p.projectid === row._id)
                                    ?.matchedRowHardwareEntries || []
                                }
                                projectDescriptionEntries={
                                  projectDescriptionEntries
                                }
                                projectTasksEntries={projectTasksEntries}
                                projectHardwareParts={projectHardwareParts}
                                loggedEmp={loggedEmp}
                                matchedOldRowWorkEntries={
                                  projectData.find((p) => p.projectid === row._id)
                                    ?.matchedOldRowWorkEntries || []
                                }
                                matchedOldRowDesctiption={
                                  projectData.find((p) => p.projectid === row._id)
                                    ?.matchedOldRowDesctiption || []
                                }
                                setIsLoading={setIsLoading}
                                isLoading={isLoading}
                                setTripDuration={setTripDuration}
                                tripDurationInput={tripDurationInput}
                              />
                            </div>
                          ) : (
                            <div
                              onClick={() => {
                                setClickedProject(row);
                                SetshowTaskTable(
                                  showTaskTable === row?._id ? null : row?._id
                                );
                                setOpenTaskIndex(
                                  openTaskIndex === index ? null : index
                                );
                                handleSelectProjectWorkEntries(
                                  row._id,
                                  projectData.find((p) => p.projectid === row._id)
                                    ?.matchedRowEntries || []
                                );
                                handleSelectProjectDescription(
                                  row._id,
                                  projectData.find((p) => p.projectid === row._id)
                                    ?.matchedRowDesctiption || []
                                );
                                handleSelectProjectHardwareParts(
                                  row._id,
                                  projectData.find((p) => p.projectid === row._id)
                                    ?.matchedRowHardwareEntries || []
                                );
                              }}
                              className="w-[100%] border-b h-12 font-medium cursor-pointer flex justify-center items-center "
                            >
                              Multiple
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                  {paginatedProjects?.length === 0 && (
                    <div className="noDataAvailable p-2">No Result Found</div>
                  )}
                </div>
              </div>
            </div>
    
            <div
              className={`pagination  flex justify-between -mt-1 text-xs items-center bg-white pb-2 pl-2 rounded-b-md ${
                paginatedProjects?.length > 0 ? "p-1" : ""
              } `}
            >
              <div>
                {totalItems > 0 ? (
                  <>
                    Showing {startIdx + 1} to {Math.min(endIdx, totalItems)} of{" "}
                    {totalItems} Entries
                  </>
                ) : (
                  <>
                    {paginatedProjects?.length > 0 && (
                      <>Showing {paginatedProjects?.length} Entries</>
                    )}
                  </>
                )}
              </div>
    
              {totalPages > 1 && (
                <div className="flex">
                  <button
                    onClick={() => setCurrentPage(1)}
                    className="px-2 py-2 mx-1 border rounded"
                    disabled={currentPage === 1}
                    title="First Page"
                  >
                    <KeyboardDoubleArrowLeftIcon className="w-5 h-5" />
                  </button>
                  <button
                    onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                    className="px-2 py-2 mx-2 border rounded"
                    disabled={currentPage === 1}
                  >
                    <ChevronRightIcon className="w-5 h-5 rotate-180" />
                  </button>
    
                  {Array.from({ length: 3 }, (_, index) => {
                    const pageNumber = currentPage - 1 + index;
                    if (pageNumber >= 1 && pageNumber <= totalPages) {
                      return (
                        <button
                          key={pageNumber}
                          onClick={() => setCurrentPage(pageNumber)}
                          className={`px-4 py-2 mx-2 border rounded ${
                            currentPage === pageNumber ? "bg-gray-300" : ""
                          }`}
                        >
                          {pageNumber}
                        </button>
                      );
                    }
                    return null;
                  })}
    
                  <button
                    onClick={() =>
                      setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                    }
                    className="px-2 py-2 mx-2 border rounded"
                    disabled={currentPage === totalPages}
                  >
                    <ChevronRightIcon className="w-5 h-5" />
                  </button>
    
                  <button
                    onClick={() => setCurrentPage(totalPages)}
                    className="px-2 py-2 mx-1 border rounded"
                    disabled={currentPage === totalPages}
                    title="Last Page"
                  >
                    <KeyboardDoubleArrowRightIcon className="w-5 h-5" />
                  </button>
                </div>
              )}
            </div>
    
            {confirmAssignPopup && (
              // assignProjectDetails &&
              <div className=" fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                <div className="bg-white rounded-lg p-4 max-w-2xl w-[80%] max-h-[90vh] overflow-auto relative">
                  <div className="flex justify-between items-start">
                    <h2 className="text-lg font-semibold mb-2">
                      Assign Project Tasks
                    </h2>
                    <button
                      onClick={() => setConfirmAssignPopup(false)}
                      className="absolute top-2 right-2 text-red-500 text-xl font-bold mr-6"
                    >
                      Close
                    </button>
                  </div>
    
                  <div className="mt-4">
                    <p className="text-base">
                      <strong>Project:</strong>{" "}
                      {/* {assignProjectDetails.proj.ProjectName} */}
                    </p>
                    <p className="text-base">
                      <strong>Employee:</strong>{" "}
                    </p>
                  </div>
    
                  <div className="mt-6">
                    <p className="text-base">
                      Are you sure you want to assign these project tasks to{" "}
                      <strong>
                        {/* {assignProjectDetails.emp.EmpFirstName}{" "}
                                {assignProjectDetails.emp.EmpLastName} */}
                      </strong>{" "}
                      ?
                    </p>
    
                    <div className="flex justify-start gap-4 mt-6">
                      <button
                        onClick={() => {
                          if (isViewOnly) return;
                          //   handleAssignTask();
                          setConfirmAssignPopup(false);
                        }}
                        disabled={isViewOnly}
                        className={`py-2 px-7 bg-[#e32278] overflow-hidden shadow-md text-white rounded-lg ${isViewOnly ? "opacity-50 cursor-not-allowed" : ""}`}
                      >
                        Yes
                      </button>
                      <button
                        onClick={() => setConfirmAssignPopup(false)}
                        className="py-2 px-7 bg-black hover:bg-white hover:text-black border border-black overflow-hidden shadow-md text-white rounded-lg"
                      >
                        No
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        </div>
  )
}

export default OPProjectassignPM